function changeLenghtPagination(box) {
  const teamLength = box.length;
  const paginationwidth = 100 / teamLength;
  box.forEach((element) => {
    element.style.width = paginationwidth + '%';
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const podcastsContainer = document.getElementById('podcasts-container');

  if (podcastsContainer) {
    const splidePod = new Splide(podcastsContainer, {
      type: 'loop',
      perPage: 2,
      focus: 'center',
      autoplay: true,
      interval: 8000,
      flickMaxPages: 2,
      updateOnMove: true,
      pagination: false,
      throttle: 300,
      padding: '10%',
      wheel: true,
      wheelSleep: 1000,
      breakpoints: {
        1200: {
          perPage: 1,
          padding: '30%',
        },
        640: {
          perPage: 1,
          padding: '5%',
        },
      },
    });
    splidePod.mount();

    var lightboxVideo = GLightbox({
      selector: '.glightbox3',
      touchNavigation: true,
      loop: true,
      autoplayVideos: false,
      plyr: {
        css: 'https://cdn.plyr.io/3.5.6/plyr.css', // Default not required to include
        js: 'https://cdn.plyr.io/3.5.6/plyr.js', // Default not required to include
        js: 'https://cdn.plyr.io/3.6.2/plyr.polyfilled.js',
        config: {
          ratio: '16:9',
          muted: false,
          hideControls: true,
          youtube: {
            noCookie: true,
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
          },
        },
      },
    });
  }

  const projectBloc = document.getElementById('projects-container');

  if (projectBloc) {
    const splide = new Splide(projectBloc, {
      type: 'loop',
      perPage: 5,
      autoplay: true,
      interval: 5000,
      updateOnMove: true,
      arrows: false,
      pagination: true,
      focus: 0,
      gap: '20px',
      omitEnd: true,
      height: '180px',
      wheel: true,
      wheelSleep: 1000,
      breakpoints: {
        1200: {
          perPage: 3,
        },
        640: {
          perPage: 2,
        },
      },
    });
    splide.mount();

    const projectPagination = document.querySelectorAll(
      '#projects-container .splide__pagination li'
    );
    changeLenghtPagination(projectPagination);
  }

  const newsletterBloc = document.getElementById('newsletters-container');

  if (newsletterBloc) {
    const splideNews = new Splide(newsletterBloc, {
      type: 'loop',
      perPage: 4,
      autoplay: true,
      interval: 5000,
      updateOnMove: true,
      arrows: false,
      pagination: true,
      focus: 0,
      omitEnd: true,
      height: '300px',
      gap: '20px',
      wheel: true,
      wheelSleep: 1000,
      padding: { left: 0, right: '10%' },
      breakpoints: {
        1200: {
          perPage: 1,
          padding: { left: 0, right: '30%' },
        },
        640: {
          perPage: 1,
          padding: { left: 0, right: '5%' },
        },
      },
    });
    splideNews.mount();

    const newsletterPagination = document.querySelectorAll(
      '#newsletters-container .splide__pagination li'
    );
    changeLenghtPagination(newsletterPagination);
  }

  const teamBloc = document.getElementById('teams-container');

  if (teamBloc) {
    const splideTeam = new Splide(teamBloc, {
      type: 'loop',
      perPage: 3,
      autoplay: true,
      interval: 5000,
      updateOnMove: true,
      arrows: false,
      pagination: true,
      focus: 0,
      omitEnd: true,
      height: '400px',
      gap: '20px',
      wheel: true,
      wheelSleep: 1000,
      padding: { left: 0, right: '10%' },
      breakpoints: {
        1200: {
          perPage: 1,
          padding: { left: 0, right: '30%' },
        },
        640: {
          perPage: 1,
          padding: { left: 0, right: '5%' },
        },
      },
    });
    splideTeam.mount();
    const teamPagination = document.querySelectorAll(
      '#teams-container .splide__pagination li'
    );
    changeLenghtPagination(teamPagination);
  }

  const photosBloc = document.getElementById('photos-container');

  if (photosBloc) {
    new Splide(photosBloc, {
      type: 'loop',
      perPage: 3,
      autoplay: true,
      interval: 5000,
      arrows: false,
      pagination: false,
      focus: 'center',
      gap: '40px',
      wheel: true,
      wheelSleep: 1000,
      reducedMotion: {
        autoplay: true,
        speed: 400,
      },
      breakpoints: {
        640: {
          perPage: 1,
          gap: '10px',
          padding: { left: '5%', right: '5%' },
        },
      },
    }).mount();
  }

  const logosBloc = document.getElementById('logos-container');

  if (logosBloc) {
    const splideLogo = new Splide(logosBloc, {
      type: 'loop',
      perPage: 4,
      autoplay: true,
      interval: 4000,
      updateOnMove: true,
      arrows: false,
      pagination: false,
      focus: 0,
      gap: '40px',
      wheel: true,
      wheelSleep: 1000,
      breakpoints: {
        1000: {
          perPage: 3,
        },
        640: {
          perPage: 1,
          gap: '10px',
          padding: { left: '5%', right: '5%' },
        },
      },
    });
    splideLogo.mount();
  }

  const ambassadeursBloc = document.getElementById('ambassadeurs-container');

  if (ambassadeursBloc) {
    const splideAmb = new Splide(ambassadeursBloc, {
      type: 'loop',
      perPage: 4,
      autoplay: true,
      interval: 4000,
      updateOnMove: true,
      arrows: false,
      pagination: true,
      focus: 0,
      gap: '20px',
      omitEnd: true,
      height: '440px',
      wheel: true,
      wheelSleep: 1000,
      padding: { left: 0, right: '10%' },
      breakpoints: {
        1200: {
          perPage: 2,
          padding: { left: 0, right: '10%' },
        },
        640: {
          perPage: 1,
          padding: { left: 0, right: '5%' },
        },
      },
    });
    splideAmb.mount();
    const ambassadeurPagination = document.querySelectorAll(
      '#ambassadeurs-container .splide__pagination li'
    );
    changeLenghtPagination(ambassadeurPagination);
  }
});
